import { Close, ArrowLeft, RestartAlt, ArrowRight } from '@mui/icons-material';
import { useRef } from 'react';
import { Api } from '../../App';
import { useAppDispatch, useAppSelector } from '../../reducers/hooks';
import { reset as materialReset } from "../../reducers/materialReducer";
import { reset as toolReset } from "../../reducers/toolReducer";
import { reset as machineReset } from "../../reducers/machineReducer";
import './Sidebar.css';

function Sidebar({step, dispatchStep, toolType, sidebarOpen, setSidebarOpen} : {step: number, dispatchStep: any, toolType: string, sidebarOpen: boolean, setSidebarOpen: any}) {
    const [material, machine, tool] = useAppSelector(state => [state.material, state.machine, state.tool]);
    const sidebarRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();

    const handleRestart = () => {
        if (window.confirm('Are you sure you want to clear your selections? You can\'t undo this.')) {
            sessionStorage.clear();
            dispatch(materialReset());
            dispatch(machineReset());
            dispatch(toolReset());
            dispatchStep('restart');
        }
    }

    const inputs = Api.getPrintAttributes(material, machine, tool);

    let materialParams = [];
    for (const key in inputs.material) {
        // @ts-ignore
        if (inputs.material[key] !== false) materialParams.push(
            <div className="editableAttribute" key={key}>
                <label>{key} </label>
                { /* @ts-ignore */}
                <b>{inputs.material[key]}</b>
            </div>
        )
    }

    let machineParams = [];
    for (const key in inputs.machine) {
        // @ts-ignore
        if (inputs.machine[key] !== false) machineParams.push(
            <div className="editableAttribute" key={key}>
                <label>{key} </label>
                { /* @ts-ignore */}
                <b>{inputs.machine[key]}</b>
            </div>
        )
    }

    let toolParams = [];
    for (const key in inputs.tool) {
        // @ts-ignore
        if (inputs.tool[key] !== false) toolParams.push(
            <div className="editableAttribute" key={key}>
                <label>{key} </label>
                { /* @ts-ignore */}
                <b>{inputs.tool[key]}</b>
            </div>
        )
    }

    return (
        <aside ref={sidebarRef} className={sidebarOpen ? 'toggled' : ''}>
            <div className="mobileTapOut" onClick={() => setSidebarOpen(false)} />
            <h2>History</h2>
            <Close onClick={() => setSidebarOpen(false)} className="btn closeBtn" />
            <div className="history">
                {(step > 1 || material.name !== '') && <div className="historyItem">
                    <div onClick={handleRestart} className="btn dangerBtn">
                        <RestartAlt />
                        <span>Start Over</span>
                    </div>
                </div>}
                {material.name !== '' && <div className="historyItem">
                    <h3>
                        <div className={step === 1 ? "btn disabledBtn" : "btn primaryBtn"} onClick={() => dispatchStep(1)}>
                            <ArrowLeft />
                        </div>
                        <div className="historyLabel">
                            <span>Material</span>
                            <span>{material.name}</span>
                        </div>
                    </h3>
                    <i>{material.description}</i>
                    {materialParams}
                </div>}
                {(step > 2 || tool.name !== '') && <div className="historyItem">
                    <h3>
                        <div className={step === 2 ? "btn disabledBtn" : "btn primaryBtn"} onClick={() => dispatchStep(2)}>
                            <ArrowLeft />
                        </div>
                        <span>Machining</span>
                    </h3>
                    {machineParams}
                </div>}
                {tool.name !== '' && <div className="historyItem">
                    <h3>
                        <div className={step === 3 ? "btn disabledBtn" : "btn primaryBtn"} onClick={() => dispatchStep(3)}>
                            <ArrowLeft />
                        </div>
                        <div className="historyLabel">
                            <span>{toolType === 'endmills' ? 'Endmill' : 'Drill'}</span>
                            <span>{tool.name}</span>
                        </div>
                    </h3>
                    <i><a target="_blank" rel="noreferrer" href={`https://www.garrtool.com/product-details/?EDP=${tool.edp}`}>EDP #{tool.edp.toString().padStart(5, '0')}</a>, Series {tool.series}</i>
                    {toolParams}
                </div>}
                {tool.name !== '' && <div className="historyItem">
                    <div onClick={() => dispatchStep(4)} className={step !== 4 ? "btn primaryBtn" : "btn disabledBtn"}>
                        <ArrowRight />
                        <span>Recalculate</span>
                    </div>
                </div>}
                <p>Your history will show up here.</p>
            </div>
        </aside>
    )
}

export default Sidebar;